import { render, staticRenderFns } from "./pkgGroupAgent.vue?vue&type=template&id=8a13a226&"
import script from "./pkgGroupAgent.vue?vue&type=script&lang=js&"
export * from "./pkgGroupAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports